import React, { useState } from 'react';
import { Drawer, Box, Divider, List } from '@mui/material';
import { NavItem, UserProfile } from '../../interfaces/userContext';
import './style.css';
import NavAppTitle from './NavAppTitle'
import NavBottomGroup from './NavBottomGroup';
import NavGroupItem, { NavGroup } from './NavGroup';
import { groupNavItems } from './utils';

interface NavDrawerProps {
    userProfile: UserProfile;
    navItems: NavItem[];
    bottomGroup: any[]
}

const NavDrawer: React.FC<NavDrawerProps> = ({ userProfile, navItems, bottomGroup }) => {
    const [open, setOpen] = useState<boolean>(true);
    const [expandedGroup, setExpandedGroup] = useState<string | null>(null);

    const handleToggleDrawer = () => {
        setOpen(prev => !prev);
        setExpandedGroup(null)
    };


    const drawerState = open ? 'drawer-open' : 'drawer-closed'
    const navGroups: NavGroup[] = groupNavItems(navItems, userProfile);

    const toggleExpand = (order: string) => {
        setExpandedGroup(prev => (prev === order ? null : order));
    };

    return (
        <Box className="nav-drawer-container">
            <Drawer
                variant="permanent"
                open={open}
                className="nav-drawer"
                classes={{
                    paper: `nav-drawer-paper ${drawerState}`,
                }}
            >
                <NavAppTitle />
                <List>
                    {navGroups.map((group, index) => (
                        <NavGroupItem
                            key={index}
                            group={group}
                            collapsed={!open}
                            expanded={expandedGroup === group.parent.order}
                            onToggle={toggleExpand}
                            open={open}
                        />
                    ))}
                </List>
                <Divider />
                <NavBottomGroup bottomGroup={bottomGroup} handleToggleDrawer={handleToggleDrawer} open={open} userProfile={userProfile} />
            </Drawer>
            <Box component="main" className={`main-content ${drawerState}`} />
        </Box>
    );
};

export default NavDrawer;